export default {
  unprocessedCommunications: null,
  communicationDetails: null,
}